module.exports = __webpack_public_path__ + "media/new-pdf-report-layout/historia-066831b4.svg";